module.exports = __webpack_public_path__ + "static/media/male.aed05712.svg";